const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/edelivery/api-factory');
const serviceFactory = require('../resources/edelivery/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}edelivery.getUserPreferences`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getUserPreferences(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}edelivery.saveUserPreferences[{keys:preference}][{keys:screen}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.saveUserPreferences(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
}

module.exports = addRoutes;
